import { connect } from "react-redux";
import PaymentInvoice from "./paymentInvoice";
import { bindActionCreators } from "redux";
import { getVendorRequestSubmit,getPaymentRequestDetails,getVendorPo,saveVendorPayment } from "services/redux/sales/vendorPortal/action";
import { documentUploadUrl } from "services/redux/fileUpload/action";


import {
  fetchZones,
} from "services/redux/sales/preSaleListing/action";

const mapStateToProps = (state) => ({
  getVendorDetails: state.vendorPortalReducer.vendorPaymentAdd,
  poDetail: state.vendorPortalReducer.poDetail
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      fetchZones,
      getVendorRequestSubmit,
      getPaymentRequestDetails,
      getVendorPo,
      saveVendorPayment,
      documentUploadUrl,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(PaymentInvoice);
